import React, { useState } from "react";
import { Form, Col } from "react-bootstrap";
import Label from "../Layout/Label";
import DocumentEditor from "../DocumentEditor/DocumentEditor";

const UploadField = ({
  label,
  name,
  id,
  value,
  changeHandler,
  lg = 6,
  req = false,
  acceptedTypes = ["pdf", "image"],
  errors,
}) => {
  const [showEditor, setShowEditor] = useState(false);

  const elementId = id || name;

  const getLabel = (v) => {
    if (!v) return "Upload File";
    if (typeof v === "string") {
      if (v.startsWith("data:")) {
        const mimeMatch = v.match(/^data:([^;]+);/);
        if (mimeMatch) {
          const mime = mimeMatch[1].toLowerCase();
          if (mime === "application/pdf") return "PDF Document Ready";
          if (mime.startsWith("image/")) return "Image Ready";
          if (mime.includes("wordprocessingml") || mime.includes("msword")) return "Word Document Ready";
          if (mime.includes("spreadsheetml") || mime.includes("ms-excel")) return "Excel Spreadsheet Ready";
          if (mime === "text/csv") return "CSV File Ready";
          if (mime === "text/plain") return "Text File Ready";
          if (mime.includes("presentationml") || mime.includes("ms-powerpoint")) return "PowerPoint Ready";
        }
      }
      return "Upload File";
    }
    return "Upload File";
  };

  const handleSave = (base64) => {
    const msgEl = document.getElementById(elementId + "_msg");
    if (msgEl) msgEl.innerText = "";
    if (changeHandler) {
      changeHandler({ target: { name, value: base64 } });
    }
    setShowEditor(false);
  };

  const handleClose = () => {
    setShowEditor(false);
  };

  return (
    <>
      <Form.Group as={Col} lg={lg}>
        {label && <Label labelName={label} req={req} />}
        <input
          id={elementId}
          name={name}
          type="hidden"
          value={typeof value === "string" ? value : ""}
        />
        <button
          type="button"
          onClick={() => setShowEditor(true)}
          className="form-control"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
            backgroundColor: value ? "#f0fdf4" : "#fff",
            color: value ? "#166534" : "#6c757d",
            borderColor: value ? "#4ade80" : "#ced4da",
            textAlign: "left",
            overflow: "hidden",
          }}
        >
          {value ? (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" style={{ flexShrink: 0 }}>
              <polyline points="20 6 9 17 4 12" />
            </svg>
          ) : (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0 }}>
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
          )}
          <span style={{ flex: 1, textAlign: "left", fontSize: "inherit", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {getLabel(value)}
          </span>
        </button>
        <p id={elementId + "_msg"} style={{ fontSize: "80%" }} className="text-danger text-sm mb-0">{errors && errors[name] ? errors[name] : ""}</p>
      </Form.Group>
      {showEditor && (
        <DocumentEditor
          open={showEditor}
          onClose={handleClose}
          onSave={handleSave}
          title={label || "Upload Document"}
          acceptedTypes={acceptedTypes}
        />
      )}
    </>
  );
};

export default UploadField;
